import Icon from '../components/Icon.vue'

Icon.register({
  'list-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 480h-416c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h416c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM128 120c-22.1 0-40 17.9-40 40s17.9 40 40 40 40-17.9 40-40-17.9-40-40-40zM128 216c-22.1 0-40 17.9-40 40s17.9 40 40 40 40-17.9 40-40-17.9-40-40-40zM128 312c-22.1 0-40 17.9-40 40s17.9 40 40 40 40-17.9 40-40-17.9-40-40-40zM416 176v-32c0-6.6-5.4-12-12-12h-200c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h200c6.6 0 12-5.4 12-12zM416 272v-32c0-6.6-5.4-12-12-12h-200c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h200c6.6 0 12-5.4 12-12zM416 368v-32c0-6.6-5.4-12-12-12h-200c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h200c6.6 0 12-5.4 12-12z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/list-alt.js
// module id = 1525
// module chunks = 0